<script setup>
    import MainHeader from './../../components/HeaderComponent.vue';
    import { useRouter } from 'vue-router';
    import { useLoginStore } from '@/stores/login/loginStore';

    const router = useRouter();

    const loginStore = useLoginStore();

    function backToLogin() {
        // ログイン画面に戻る。
        router.push({ name: 'login', query: { vid: loginStore.vendorId } });
    }
</script>

<template>
    <section id="main" class="login extra">
        <MainHeader />
        <div id="contents" class="small">
            <h2>{{ $t('signinResetComplete.parts.pageTitle1') }}</h2>
            <h3 style="text-align: center; padding-top: 30px">{{ $t('signinResetComplete.parts.pageInformation1') }}</h3>
            <ul class="btnArea" style="padding-top: 40px">
                <li>
                    <button type="button" class="btnPrimary" @click="backToLogin">{{ $t('signinResetComplete.parts.button1') }}</button>
                </li>
            </ul>
        </div>
    </section>
</template>

<style></style>
